import { render } from "./InviiComponent.vue?vue&type=template&id=8981fe38&scoped=true"
import script from "./InviiComponent.vue?vue&type=script&lang=js"
export * from "./InviiComponent.vue?vue&type=script&lang=js"

import "./InviiComponent.vue?vue&type=style&index=0&id=8981fe38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8981fe38"]])

export default __exports__